$(function(){
    var swiperBank = new Swiper('#swiperBank',{
        loop: true,
        autoplay: 2000,
        slidesPerView : 6,
        offsetSlidesAfter : 2,
        autoplayDisableOnInteraction : false,
    })
    $('#swiperBank-prev').click(function(){
        swiperBank.swipePrev(); 
    })
    $('#swiperBank-next').click(function(){
        swiperBank.swipeNext(); 
    })
    $('.mar .item').on('mouseover',function(){
        var i = $(this).index();
        var arr = $(".page").children()[i].className;
        $(this).addClass("actived").siblings().removeClass("actived");
        $(".page ."+arr).show().siblings().hide();
    })
})
